import React from 'react'
import { locale } from 'i18n'

const TransferInformation = (props) => {
  const { place } = props
  const transferInfo = locale === 'lv' ? place.transfer_information_lv : place.transfer_information_en

  return (
    <div className='info-container transfer-information'>
      <div>
        <span dangerouslySetInnerHTML={{ __html: transferInfo }}></span>
      </div>
    </div>
  )
}
export default TransferInformation
